// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"1f4039b8","480":"09d6e7eb","838":"fe9c8d82"}[chunkId] + ".js";
};